import ArrowUp from '../../src/legacy/ArrowUp.tsx';
export default ArrowUp;
